import { BellAlertIcon } from "@heroicons/react/24/outline";

import { useSendTestNotification } from "../../hooks/notifications/useSendTestNotification";
import BadgeButton from "../shared/BadgeButton";
import Card from "../shared/card";
import Typography from "../shared/typography";

const SendTestNotificationCard = () => {
  const { mutate, isPending } = useSendTestNotification();

  return (
    <Card className="mb-12 w-full" variant="cream" elevation={2}>
      <Card.Header
        variant="cream"
        className="flex flex-col gap-4 bg-cream-100 sm:flex-row sm:items-center sm:justify-between"
      >
        <div className="flex items-center gap-3 text-terracotta">
          <BellAlertIcon className="h-6 w-6" aria-hidden="true" />
          <Typography variant="h4" className="text-terracotta">
            Test Push Notification
          </Typography>
        </div>
        <BadgeButton
          tone="primary"
          variant="solid"
          onClick={() => mutate()}
          disabled={isPending}
        >
          {isPending ? "Sending..." : "Send test push"}
        </BadgeButton>
      </Card.Header>
      <Card.Body className="space-y-2 bg-white">
        <Typography variant="body2" className="text-brown-700">
          Trigger a single push notification to confirm your device can receive
          Harper alerts.
        </Typography>
        <Typography variant="caption" className="text-brown-500">
          We will use the phone tied to your admin account, so no extra input is
          needed.
        </Typography>
      </Card.Body>
    </Card>
  );
};

export default SendTestNotificationCard;
